import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { FilesListComponent } from './files-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { FilesService } from "./files.service";

@Component({
    selector: 'convfact-fileopen',
    templateUrl: './files-dialog-edit.component.html',
    styleUrls: ['./files.component.css'],
    standalone: false
})
export class FilesDialogEditComponent {

    newName: string;
    path: string = this.data.path;
    uid: string = this.data.uid;
    isDirectory: string = this.data.isDirectory;
    type: string = this.data.type;
    error_msg: string;
    error: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<FilesListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        private fileService: FilesService
    ) { }

    displayInfo(message: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10000;
        options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
    }

    renameElement() {
        if (this.newName == null || this.newName == "") {
            this.error = true;
            this.error_msg = "Debe indicar un nombre";
        } else {
            const formData: FormData = new FormData();
            formData.append('type', this.type);
            formData.append('note', this.newName);
            formData.append('path', this.path);
            formData.append('isDirectory', this.isDirectory);
            this.fileService.editData(this.uid, formData).then(response => {
                this.displayInfo(response);
            })
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }

}